import { ApiState } from '../../utils/requestAction';
import requestReducer from '../requestReducer';
import PreorderDetail from '../../models/PreorderDetail';


export interface PreorderDetailDataState extends ApiState {
  preorderDetail?: PreorderDetail
}

export default requestReducer<PreorderDetailDataState>('PREORDER_DETAIL_DATA')
